export const PLATFORMISED_API_URL = '/_api/communities-blog-node-api/v3';
